import { brandApproved } from 'services/typewriter';
import { flatten } from '../../../utils';
import {
  getEntity,
  segmentBrandObject,
  segmentCompanyObject,
  segmentContextObject,
} from './helpers';

export default async ({ data: values }: Data) => {
  const { history, updated } = values;
  const lastTransition = history[ history.length -1 ] ?? updated;
  const brand = flatten(values);
  const company = await getEntity('companies', brand['company']);
  brandApproved({
    context: segmentContextObject(company, brand),
    brand: segmentBrandObject(brand, company),
    company: segmentCompanyObject(company),
    approver: {
      id: lastTransition?.by?.id,
      email: lastTransition?.by?.mail,
    }
  });
};
